import React, { useEffect ,useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  DialogTitle,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import {
  createEmploymentTypeUrl,
  updateEmploymentTypeUrl,
  deleteEmploymentTypeUrl
} from "../../../../Library/URLs";
// import { CircularProgress } from "@mui/material";
import axios from "axios";
import { v4 as uuid } from "uuid";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
    width: "552px",
    fontFamily: "Quicksand",
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
    fontFamily: "Quicksand",
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2,fontFamily:'Quicksand, sans-serif' }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

export const CreateEmploymentType = ({ open, handleClose, updateEmploymentTypes }) => {
  const unique_id = uuid();
  const { companyid } = useParams();
  const { User } = useSelector((state) => state.payroll);
  // const proxyEmployee = useSelector((state) => state.payroll.Proxy);
  const initState = {
    type: "",
  };
  const [formData, setFormData] = useState(initState);
  const [isLoading, setIsLoading] = useState(false)

  const createEmploymentType = async () => {
    // console.log('all employee API is call')
    setIsLoading(true);
    const raw = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
      type: formData.type
    };
    await axios
      .post(createEmploymentTypeUrl, raw)
      .then((res) => {
        setIsLoading(false);
        if (res.data.success === true) {
          toast.success(res.data?.data);
          setFormData(initState);
          handleClose();
          updateEmploymentTypes();
        } else {
          toast.error(res.data?.message);
        }
      })
      .catch((err) => {
        console.log("error" + err.message);
        toast.error("Request Failed");
        setIsLoading(false);
      });
  };

  const closeDialog = () => {
    handleClose();
    setFormData(initState);
  };

  const dashboardTheme = window.localStorage.getItem("theme");

  return (
    <BootstrapDialog
      onClose={closeDialog}
      aria-labelledby="customized-dialog-title"
      open={open}
      // maxWidth={'sm'}
      // fullWidth={true}
      className="Dialog_Wrap"
    >
      <BootstrapDialogTitle id="customized-dialog-title" onClose={closeDialog}>
        <div className="Name">Create Employment Type</div>
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <div className="">
          <div className="Content_Wrap">
            <div className="Box">
              <label htmlFor="">Name</label>
              <input
                name="type"
                value={formData.type}
                onChange={(e) =>
                  setFormData({ ...formData, type: e.target.value })
                }
                type="text"
              />
            </div>
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <div className="Pay_Item_Btn_Action_Wrapper">
          <div className="Btn" onClick={handleClose}>
            Cancel
          </div>

          <div
            className="Btn"
            onClick={createEmploymentType}
            style={{
              backgroundColor: dashboardTheme ? dashboardTheme : "#13ABF4",
            }}
          >
            {isLoading === true ? (
              <span className="spinner-border spinner-grow-sm" />
            ) : (
              "Create"
            )}
          </div>
        </div>
      </DialogActions>
    </BootstrapDialog>
  );
};

export const EditEmploymentType = ({ open, handleClose, updateEmploymentList, employment_type }) => {
  const unique_id = uuid();
  const { companyid } = useParams();
  const { User } = useSelector((state) => state.payroll);
  const proxyEmployee = useSelector((state) => state.payroll.Proxy);
  const initState = {
    type: "",
  };
  const [formData, setFormData] = useState(initState);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setFormData({
      ...formData,
      type: employment_type?.type,
    });
    // eslint-disable-next-line
  }, [employment_type]);

  const updateEmploymentType = async () => {
    // console.log('all employee API is call')
    setIsLoading(true);
    const raw = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
      proxy_id: proxyEmployee?.success?proxyEmployee?.id:null,
      type: formData.type,
      employment_type_id: employment_type?.id
    };
    await axios
      .post(updateEmploymentTypeUrl, raw)
      .then((res) => {
        setIsLoading(false);
        if (res.data.success === true) {
          toast.success(res.data?.data);
          handleClose();
          updateEmploymentList();
        } else {
          toast.error(res.data?.message);
        }
      })
      .catch((err) => {
        console.log("error" + err.message);
        toast.error("Request Failed");
        setIsLoading(false);
      });
  };

  const dashboardTheme = window.localStorage.getItem("theme");

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      // maxWidth={'sm'}
      // fullWidth={true}
      className="Dialog_Wrap"
    >
      <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
        <div className="Name">Edit Employment Type</div>
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <div className="">
          <div className="Content_Wrap">
            <div className="Box">
              <label htmlFor="">Name</label>
              <input
                name="type"
                value={formData.type}
                onChange={(e) =>
                  setFormData({ ...formData, type: e.target.value })
                }
                type="text"
              />
            </div>
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <div className="Pay_Item_Btn_Action_Wrapper">
          <div className="Btn" onClick={handleClose}>
            Cancel
          </div>

          <div
            className="Btn"
            style={{
              backgroundColor: dashboardTheme ? dashboardTheme : "#13ABF4",
            }}
            onClick={updateEmploymentType}
          >
            {isLoading === true ? (
              <span className="spinner-border spinner-grow-sm" />
            ) : (
              "Update"
            )}
          </div>
        </div>
      </DialogActions>
    </BootstrapDialog>
  );
};

export const DeleteEmploymentType = ({ open, handleClose, updateEmploymentType, employmentType }) => {
  const unique_id = uuid();
  const { companyid } = useParams();
  const { User } = useSelector((state) => state.payroll);
  const proxyEmployee = useSelector((state) => state.payroll.Proxy);

  const [isLoading, setIsLoading] = useState(false);

  const deleteEmploymentType = async () => {
    // console.log('all employee API is call')
    setIsLoading(true);
    const raw = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
      employment_type_id: employmentType,
      proxy_id: proxyEmployee?.success?proxyEmployee?.id:null,
    };
    await axios
      .post(deleteEmploymentTypeUrl, raw)
      .then((res) => {
        setIsLoading(false);
        if (res.data.success === true) {
          toast.success(res.data?.data);
          handleClose();
          updateEmploymentType();
        } else {
          toast.error(res.data?.message);
        }
      })
      .catch((err) => {
        console.log("error" + err.message);
        toast.error("Request Failed");
        setIsLoading(false);
      });
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      // maxWidth={'sm'}
      // fullWidth={true}
      className="Dialog_Wrap"
    >
      <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
        <div className="Name">Delete Employment Type</div>
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <div>
          <div className="Confirmation" >
            Are you sure?
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <div className="Pay_Item_Btn_Action_Wrapper">
          <div className="Btn" onClick={handleClose}>
            Cancel
          </div>

          <div className="Btn Delete_Btn" onClick={deleteEmploymentType}>
            {isLoading === true ? (
              <span className="spinner-border spinner-grow-sm" />
            ) : (
              "Delete"
            )}
          </div>
        </div>
      </DialogActions>
    </BootstrapDialog>
  );
};